'use strict';

/*!
 * for Background Canvas
 *
 * @deps pixi.min, jquery
 */

// top のデフォルトOption

const TOP_OPTION = {
	mode: 'animation',
	layers: [
		{
			id: 7,
			circles: [
				{
					pos: [ 804, 258 ],
					size: 764,
					color: 0xf069af,
				},
				{
					pos: [ 403, 484 ],
					size: 749,
					color: 0x2296eb,
				},
				{
					pos: [ 416, -545 ],
					size: 1366,
					color: 0x4ac1d8,
				},
				{
					pos: [ -240, 161 ],
					size: 724,
					color: 0x8df9ca,
				},
				{
					pos: [ -407, -10 ],
					size: 724,
					color: 0x2578e8,
				},
				{
					pos: [ 998, -561 ],
					size: 918,
					color: 0x62b0ff,
				},
			],
		},
		{
			id: 6,
			circles: [
				{
					pos: [ 425, 548 ],
					size: 1371,
					color: 0x2095ea,
				},
				{
					pos: [ 708, -152 ],
					size: 879,
					color: 0x40d2fc,
				},
				{
					pos: [ 835, -400 ],
					size: 896,
					color: 0xfcb073,
				},
				{
					pos: [ -4, 391 ],
					size: 913,
					color: 0xff1854,
				},
				{
					pos: [ 95, -535 ],
					size: 633,
					color: 0x228be6,
				},
				{
					pos: [ -158, -807 ],
					size: 1192,
					color: 0x2095ea,
				},
			],
		},
		{
			id: 5,
			circles: [
				{
					pos: [ 892, 597 ],
					size: 921,
					color: 0x76ff5e,
				},
				{
					pos: [ 425, 114 ],
					size: 1371,
					color: 0x2698ea,
				},
				{
					pos: [ 708, -586 ],
					size: 879,
					color: 0x40d2fc,
				},
				{
					pos: [ -4, -43 ],
					size: 913,
					color: 0xff1854,
				},
				{
					pos: [ -231, 551 ],
					size: 473,
					color: 0x1f89e6,
				},
			],
		},
		{
			id: 4,
			circles: [
				{
					pos: [ 0, 627 ],
					size: 759,
					color: 0x1f94ea,
				},
				{
					pos: [ 210, -100 ],
					size: 981,
					color: 0x1f94ea,
				},
				{
					pos: [ -100, -9 ],
					size: 389,
					color: 0x5674d4,
				},
				{
					pos: [ -282, -26 ],
					size: 588,
					color: 0xfab863,
				},
				{
					pos: [ 654, 241 ],
					size: 1332,
					color: 0x0358a9,
				},
				{
					pos: [ 1102, 267 ],
					size: 524,
					color: 0xf042bd,
				},
			],
		},
		{
			id: 3,
			circles: [
				{
					pos: [ 0, 627 ],
					size: 389,
					color: 0x2196ea,
				},
				{
					pos: [ 308, 169 ],
					size: 389,
					color: 0x5674d4,
				},
				{
					pos: [ -21, -230 ],
					size: 774,
					color: 0xff4265,
				},
				{
					pos: [ 654, -399 ],
					size: 1332,
					color: 0x3eb9f9,
				},
				{
					pos: [ 810, -589 ],
					size: 824,
					color: 0xdffac9,
				},
			],
		},
		{
			id: 2,
			circles: [
				{
					pos: [ 0, 627 ],
					size: 759,
					color: 0x1f94ea,
				},
				{
					pos: [ 260, 246 ],
					size: 389,
					color: 0xc456d4,
				},
				{
					pos: [ 21, 8 ],
					size: 478,
					color: 0xff4063,
				},
				{
					pos: [ 883, -78 ],
					size: 921,
					color: 0xb1f264,
				},
				{
					pos: [ 416, -561 ],
					size: 1371,
					color: 0x2598ea,
				},
			],
		},
		{
			id: 1,
			circles: [
				{
					pos: [ 0, 627 ],
					size: 759,
					color: 0x2095ea,
				},
				{
					pos: [ -107, -154 ],
					size: 389,
					color: 0x5674d4,
				},
				{
					pos: [ -390, 345 ],
					size: 725,
					color: 0xa9eb7c,
				},
				{
					pos: [ -342, -350 ],
					size: 556,
					color: 0xff4164,
				},
				{
					pos: [ 883, -255 ],
					size: 921,
					color: 0xe059e5,
				},
				{
					pos: [ 549, -74 ],
					size: 1192,
					color: 0x2196ea,
				},
			],
		},
	],
	speed: {
		scrollMultiply: 8,
		inTime: {
			min: 1000,
			max: 2500,
		},
		outTime: {
			min: 1000,
			max: 2500,
		},
	},
	fixed: true,
};
const MORNING_COMMON_OPTION = {
	color: [
		{
			color: 0xABEB7F,
			alpha: 1,
			gradationType: 1,
		},
		{
			color: 0x2095EA,
			alpha: 0.6,
			gradationType: 1,
		},
		{
			color: 0xF06DB1,
			alpha: 0.6,
			gradationType: 1,
		},
	],
};
const MORNING_3RD_OPTION = {
	...MORNING_COMMON_OPTION,
	positions: [ {
		pos: [ -259, 4540 ],
		size: 799,
		colorIndex: 1,
		isBottom: true,
	}, {
		pos: [ -370, 4558 ],
		size: 1231,
		colorIndex: 0,
		isBottom: true,
	}, {
		pos: [ 540, 5248 ],
		size: 937,
		colorIndex: 2,
		isBottom: true,
	}, {
		pos: [ 662, 4794 ],
		size: 1300,
		colorIndex: 0,
		isBottom: true,
	}, {
		pos: [ 257, -285 ],
		size: 677,
		colorIndex: 1,
	}, {
		pos: [ -371, 141 ],
		size: 806,
		colorIndex: 1,
	}, {
		pos: [ -358, 358 ],
		size: 1058,
		colorIndex: 0,
	}, {
		pos: [ 725, -365 ],
		size: 1075,
		colorIndex: 0,
	}, {
		pos: [ 461, -392 ],
		size: 683,
		colorIndex: 2,
	} ],
};
const MORNING_OPTION = {
	...MORNING_COMMON_OPTION,
	positions: [
		...MORNING_3RD_OPTION.positions,
		{
			pos: [ -321, 1773 ],
			size: 727,
			colorIndex: 2,
		}, {
			pos: [ -210, 1911 ],
			size: 910,
			colorIndex: 1,
		}, {
			pos: [ 1046, 879 ],
			size: 786,
			colorIndex: 2,
		}, {
			pos: [ 618, 879 ],
			size: 1288,
			colorIndex: 0,
		}, {
			pos: [ -624, 2053 ],
			size: 1434,
			colorIndex: 0,
		} ],
};
const MORNING_3RD_SP_OPTION = {
	...MORNING_COMMON_OPTION,
	positions: [
		{
			pos: [ 267, 10244 ],
			size: 700,
			colorIndex: 2,
			isBottom: true,
		},
		{
			pos: [ 138, -194 ],
			size: 474,
			colorIndex: 2,
			isBottom: false,
		},
		{
			pos: [ 270, -215 ],
			size: 823,
			colorIndex: 0,
			isBottom: false,
		},
		{
			pos: [ -20, -65 ],
			size: 500,
			colorIndex: 1,
			isBottom: false,
		},
		{
			pos: [ -210, 545 ],
			size: 529,
			colorIndex: 1,
			isBottom: false,
		},
		{
			pos: [ -420, 595 ],
			size: 956,
			colorIndex: 0,
			isBottom: false,
		},
		{
			pos: [ -294, 8938 ],
			size: 669,
			colorIndex: 1,
			isBottom: true,
		},
		{
			pos: [ -461, 9011 ],
			size: 1193,
			colorIndex: 0,
			isBottom: true,
		},
		{
			pos: [ 267, 9792 ],
			size: 931,
			colorIndex: 0,
			isBottom: true,
		},
	],
};
const MORNING_SP_OPTION = {
	...MORNING_COMMON_OPTION,
	positions: [
		...MORNING_3RD_SP_OPTION.positions,
		{
			pos: [ -325, 2897 ],
			size: 700,
			colorIndex: 2,
			isBottom: false,
		},
		{
			pos: [ -133, 2994 ],
			size: 669,
			colorIndex: 1,
			isBottom: false,
		},
		{
			pos: [ 421, 1437 ],
			size: 700,
			colorIndex: 2,
			isBottom: false,
		},
		{
			pos: [ 110, 1484 ],
			size: 1143,
			colorIndex: 0,
			isBottom: false,
		},
		{
			pos: [ -596, 3047 ],
			size: 1193,
			colorIndex: 0,
			isBottom: false,
		},
	],
};
const NOON_COMMON_OPTION = {
	color: [ {
		color: 0x38A1ED,
		alpha: 1,
		gradationType: 1,
	},
	{
		color: 0xabeb7f,
		alpha: 0.6,
		gradationType: 1,
	},
	{
		color: 0xf06db1,
		alpha: 0.6,
		gradationType: 1,
	} ],
};
const NOON_3RD_OPTION = {
	...NOON_COMMON_OPTION,
	positions: [
		{
			pos: [ -280, 4940 ],
			size: 693,
			colorIndex: 2,
			isBottom: true,
		},
		{
			pos: [ 675, 5191 ],
			size: 683,
			colorIndex: 1,
			isBottom: true,
		},
		{
			pos: [ 817, -171 ],
			size: 603,
			colorIndex: 1,
			isBottom: false,
		},
		{
			pos: [ -338, 562 ],
			size: 725,
			colorIndex: 1,
			isBottom: false,
		},
		{
			pos: [ 49, -350 ],
			size: 651,
			colorIndex: 2,
			isBottom: false,
		},
		{
			pos: [ 958, -171 ],
			size: 1000,
			colorIndex: 0,
			isBottom: false,
		},
		{
			pos: [ -523, 190 ],
			size: 1046,
			colorIndex: 0,
			isBottom: false,
		},
		{
			pos: [ 586, 4705 ],
			size: 1278,
			colorIndex: 0,
			isBottom: true,
		},
		{
			pos: [ -454, 5054 ],
			size: 1278,
			colorIndex: 0,
			isBottom: true,
		},
	],
};
const NOON_OPTION = {
	...NOON_COMMON_OPTION,
	positions: [
		...NOON_3RD_OPTION.positions,
		{
			pos: [ 793, 1018 ],
			size: 584,
			colorIndex: 1,
			isBottom: false,
		},
		{
			pos: [ 958, 757 ],
			size: 1000,
			colorIndex: 2,
			isBottom: false,
		},
		{
			pos: [ 23, 2120 ],
			size: 627,
			colorIndex: 2,
			isBottom: false,
		},
		{
			pos: [ -412, 1826 ],
			size: 881,
			colorIndex: 1,
			isBottom: false,
		},
		{
			pos: [ 728, 1018 ],
			size: 1192,
			colorIndex: 0,
			isBottom: false,
		},
		{
			pos: [ -531, 2240 ],
			size: 1299,
			colorIndex: 0,
			isBottom: false,
		},
	],
};
const NOON_3RD_SP_OPTION = {
	...NOON_COMMON_OPTION,
	positions: [
		{
			pos: [ 206, -244 ],
			size: 700,
			colorIndex: 1,
			isBottom: false,
		},
		{
			pos: [ -286, 869 ],
			size: 700,
			colorIndex: 1,
			isBottom: false,
		},
		{
			pos: [ -527, 366 ],
			size: 1104,
			colorIndex: 0,
			isBottom: false,
		},
		{
			pos: [ -244, -106 ],
			size: 489,
			colorIndex: 2,
			isBottom: false,
		},
		{
			pos: [ 327, -137 ],
			size: 846,
			colorIndex: 0,
			isBottom: false,
		},
		{
			pos: [ -375, 9760 ],
			size: 679,
			colorIndex: 2,
			isBottom: true,
		},
		{
			pos: [ 173, 9281 ],
			size: 747,
			colorIndex: 1,
			isBottom: true,
		},
		{
			pos: [ -506, 9938 ],
			size: 1104,
			colorIndex: 0,
			isBottom: true,
		},
		{
			pos: [ 89, 8856 ],
			size: 1104,
			colorIndex: 0,
			isBottom: true,
		},
	],
};
const NOON_SP_OPTION = {
	...NOON_COMMON_OPTION,
	positions: [
		...NOON_3RD_SP_OPTION.positions,
		{
			pos: [ -325, 2963 ],
			size: 700,
			colorIndex: 1,
			isBottom: false,
		},
		{
			pos: [ 455, 1379 ],
			size: 679,
			colorIndex: 2,
			isBottom: false,
		},
		{
			pos: [ 302, 1530 ],
			size: 559,
			colorIndex: 1,
			isBottom: false,
		},
		{
			pos: [ 150, 1537 ],
			size: 1104,
			colorIndex: 0,
			isBottom: false,
		},
		{
			pos: [ -488, 3111 ],
			size: 1104,
			colorIndex: 0,
			isBottom: false,
		},
	],
};
const NIGHT_COMMON_OPTION = {
	color: [
		{
			color: 0xf06db1,
			alpha: 1,
			gradationType: 1,
		},
		{
			color: 0xabeb7f,
			alpha: 0.6,
			gradationType: 1,
		},
		{
			color: 0x2095ea,
			alpha: 0.6,
			gradationType: 1,
		},
	],
};
const NIGHT_3RD_OPTION = {
	...NIGHT_COMMON_OPTION,
	positions: [
		{
			pos: [ -366, 147 ],
			size: 599,
			colorIndex: 2,
			isBottom: false,
		},
		{
			pos: [ -9, -202 ],
			size: 509,
			colorIndex: 1,
			isBottom: false,
		},
		{
			pos: [ -460, 126 ],
			size: 1029,
			colorIndex: 0,
			isBottom: false,
		},
		{
			pos: [ 1036, -121 ],
			size: 494,
			colorIndex: 2,
			isBottom: false,
		},
		{
			pos: [ 604, -445 ],
			size: 926,
			colorIndex: 0,
			isBottom: false,
		},
		{
			pos: [ 1077, 316 ],
			size: 590,
			colorIndex: 1,
			isBottom: false,
		},
		{
			pos: [ -269, 5192 ],
			size: 635,
			colorIndex: 2,
			isBottom: true,
		},
		{
			pos: [ 574, 4988 ],
			size: 1303,
			colorIndex: 0,
			isBottom: true,
		},
		{
			pos: [ 1108, 4920 ],
			size: 585,
			colorIndex: 1,
			isBottom: true,
		},
		{
			pos: [ -379, 4673 ],
			size: 1201,
			colorIndex: 0,
			isBottom: true,
		},
	],
};
const NIGHT_OPTION = {
	...NIGHT_COMMON_OPTION,
	positions: [
		...NIGHT_3RD_OPTION.positions,
		{
			pos: [ 822, 1383 ],
			size: 706,
			colorIndex: 2,
			isBottom: false,
		},
		{
			pos: [ -247, 1890 ],
			size: 761,
			colorIndex: 2,
			isBottom: false,
		},
		{
			pos: [ 25, 2715 ],
			size: 620,
			colorIndex: 1,
			isBottom: false,
		},
		{
			pos: [ 700, 907 ],
			size: 1182,
			colorIndex: 0,
			isBottom: false,
		},
		{
			pos: [ -519, 2028 ],
			size: 1229,
			colorIndex: 0,
			isBottom: false,
		},
	],
};
const NIGHT_3RD_SP_OPTION = {
	...NIGHT_COMMON_OPTION,
	positions: [
		{
			pos: [ 375, 88 ],
			size: 572,
			colorIndex: 2,
			isBottom: false,
		},
		{
			pos: [ -337, 519 ],
			size: 572,
			colorIndex: 2,
			isBottom: false,
		},
		{
			pos: [ -450, 574 ],
			size: 1034,
			colorIndex: 0,
			isBottom: false,
		},
		{
			pos: [ 341, 224 ],
			size: 700,
			colorIndex: 1,
			isBottom: false,
		},
		{
			pos: [ 36, -281 ],
			size: 892,
			colorIndex: 0,
			isBottom: false,
		},
		{
			pos: [ -375, 9381 ],
			size: 813,
			colorIndex: 2,
			isBottom: true,
		},
		{
			pos: [ 375, 9624 ],
			size: 700,
			colorIndex: 1,
			isBottom: true,
		},
		{
			pos: [ 48, 9809 ],
			size: 1282,
			colorIndex: 0,
			isBottom: true,
		},
		{
			pos: [ -475, 8832 ],
			size: 1282,
			colorIndex: 0,
			isBottom: true,
		},
	],
};
const NIGHT_SP_OPTION = {
	...NIGHT_COMMON_OPTION,
	positions: [
		...NIGHT_3RD_SP_OPTION.positions,
		{
			pos: [ -298, 2938 ],
			size: 813,
			colorIndex: 2,
			isBottom: false,
		},
		{
			pos: [ -295, 3587 ],
			size: 700,
			colorIndex: 1,
			isBottom: false,
		},
		{
			pos: [ 227, 1864 ],
			size: 701,
			colorIndex: 2,
			isBottom: false,
		},
		{
			pos: [ 149, 1324 ],
			size: 1282,
			colorIndex: 0,
			isBottom: false,
		},
		{
			pos: [ -641, 2918 ],
			size: 1282,
			colorIndex: 0,
			isBottom: false,
		},
	],
};
const TODAY_COMMON_OPTION = {
	color: [
		{
			color: 0x2b91ee,
			alpha: 0.5,
			gradationType: 1,
		},
		{
			color: 0x2b91ee,
			alpha: 0.3,
			gradationType: 1,
		},
		{
			color: 0xeee72a,
			alpha: 0.4,
			gradationType: 1,
		},
	],
};
const TODAY_OPTION = {
	...TODAY_COMMON_OPTION,
	positions: [
		{
			pos: [ -29, 4964 ],
			size: 564,
			colorIndex: 1,
			isBottom: true,
		},
		{
			pos: [ -429, 5033 ],
			size: 1036,
			colorIndex: 0,
			isBottom: true,
		},
		{
			pos: [ -29, 5260 ],
			size: 950,
			colorIndex: 2,
			isBottom: true,
		},
		{
			pos: [ 1116, 4944 ],
			size: 508,
			colorIndex: 0,
			isBottom: true,
		},
		{
			pos: [ 607, 4472 ],
			size: 1017,
			colorIndex: 2,
			isBottom: true,
		},
		{
			pos: [ 717, 5020 ],
			size: 885,
			colorIndex: 1,
			isBottom: true,
		},
		{
			pos: [ -27, 179 ],
			size: 394,
			colorIndex: 2,
			isBottom: false,
		},
		{
			pos: [ -127, 207 ],
			size: 952,
			colorIndex: 0,
			isBottom: false,
		},
		{
			pos: [ 825, -183 ],
			size: 514,
			colorIndex: 2,
			isBottom: false,
		},
		{
			pos: [ -236, 2049 ],
			size: 496,
			colorIndex: 0,
			isBottom: false,
		},
		{
			pos: [ 621, 1197 ],
			size: 1164,
			colorIndex: 1,
			isBottom: false,
		},
		{
			pos: [ -381, 2116 ],
			size: 1178,
			colorIndex: 1,
			isBottom: false,
		},
		{
			pos: [ 1010, 1003 ],
			size: 716,
			colorIndex: 0,
			isBottom: false,
		},
		{
			pos: [ 980, -82 ],
			size: 986,
			colorIndex: 1,
			isBottom: false,
		},
		{
			pos: [ 847, 1079 ],
			size: 532,
			colorIndex: 2,
			isBottom: false,
		},
		{
			pos: [ -234, 595 ],
			size: 781,
			colorIndex: 2,
			isBottom: false,
		},
		{
			pos: [ 921, 403 ],
			size: 441,
			colorIndex: 0,
			isBottom: false,
		},
		{
			pos: [ -214, 1805 ],
			size: 746,
			colorIndex: 2,
			isBottom: false,
		},
	],
};
const TODAY_SP_OPTION = {
	...TODAY_COMMON_OPTION,
	positions: [
		{
			pos: [ -143, 9511 ],
			size: 564,
			colorIndex: 1,
			isBottom: true,
		},
		{
			pos: [ -555, 9541 ],
			size: 1036,
			colorIndex: 0,
			isBottom: true,
		},
		{
			pos: [ -200, 9776 ],
			size: 950,
			colorIndex: 2,
			isBottom: true,
		},
		{
			pos: [ 475, 9106 ],
			size: 508,
			colorIndex: 0,
			isBottom: true,
		},
		{
			pos: [ 110, 8614 ],
			size: 1017,
			colorIndex: 2,
			isBottom: true,
		},
		{
			pos: [ 139, 9123 ],
			size: 885,
			colorIndex: 1,
			isBottom: true,
		},
		{
			pos: [ -370, 447 ],
			size: 952,
			colorIndex: 0,
			isBottom: false,
		},
		{
			pos: [ 231, -151 ],
			size: 514,
			colorIndex: 2,
			isBottom: false,
		},
		{
			pos: [ 0, 1388 ],
			size: 1164,
			colorIndex: 1,
			isBottom: false,
		},
		{
			pos: [ -469, 2674 ],
			size: 1178,
			colorIndex: 1,
			isBottom: false,
		},
		{
			pos: [ 392, 1110 ],
			size: 716,
			colorIndex: 0,
			isBottom: false,
		},
		{
			pos: [ 257, -106 ],
			size: 986,
			colorIndex: 1,
			isBottom: false,
		},
		{
			pos: [ 216, 1322 ],
			size: 532,
			colorIndex: 2,
			isBottom: false,
		},
		{
			pos: [ -390, 880 ],
			size: 781,
			colorIndex: 2,
			isBottom: false,
		},
		{
			pos: [ 444, 408 ],
			size: 441,
			colorIndex: 0,
			isBottom: false,
		},
		{
			pos: [ -171, 331 ],
			size: 394,
			colorIndex: 2,
			isBottom: false,
		},
		{
			pos: [ -273, 2654 ],
			size: 496,
			colorIndex: 0,
			isBottom: false,
		},
		{
			pos: [ -264, 2322 ],
			size: 746,
			colorIndex: 2,
			isBottom: false,
		},
	],
};
const SECOUND_LAYER_OPTION = {
	mode: 'static',
	fixed: false,
	color: [],
	positions: [],
};
const THIRD_LAYER_OPTION = {
	mode: 'static',
	fixed: false,
	color: [],
	positions: [],
};

const CAMPUSLIFE_COMMON_OPTION = {
	color: [
		{
			// color: 0xe4a52d,
			color: 0xe4a01d,
			alpha: 0.2,
			gradationType: 4,
		},
		{
			// color: 0xd87f55,
			color: 0xd77648,
			alpha: 0.3,
			gradationType: 3,
		},
		{
			// color: 0xfc4068,
			color: 0xfe305c,
			alpha: 0.2,
			gradationType: 2,
		},
	],
};
const CAMPUSLIFE_OPTION = {
	...CAMPUSLIFE_COMMON_OPTION,
	positions: [
		{
			pos: [ -153, 402 ],
			size: 702,
			colorIndex: 2,
		},
		{
			pos: [ 178, 477 ],
			size: 385,
			colorIndex: 0,
		},
		{
			pos: [ 91, -134 ],
			size: 651,
			colorIndex: 2,
		},
		{
			pos: [ 921, -160 ],
			size: 502,
			colorIndex: 1,
		},
		{
			pos: [ 0, -207 ],
			size: 482,
			colorIndex: 1,
		},
		{
			pos: [ -115, 86 ],
			size: 391,
			colorIndex: 0,
		},
		{
			pos: [ 700, 540 ],
			size: 526,
			colorIndex: 1,
		},
		{
			pos: [ 818, 218 ],
			size: 424,
			colorIndex: 0,
		},
		{
			pos: [ 812, 178 ],
			size: 811,
			colorIndex: 2,
		},
	],
};
const CAMPUSLIFE_SP_OPTION = {
	...CAMPUSLIFE_COMMON_OPTION,
	positions: [
		{
			pos: [ 479, 944 ],
			size: 480,
			colorIndex: 1,
		},
		{
			pos: [ 468, -114 ],
			size: 502,
			colorIndex: 1,
		},
		{
			pos: [ -119, -12 ],
			size: 376,
			colorIndex: 1,
		},
		{
			pos: [ 314, 321 ],
			size: 811,
			colorIndex: 2,
		},
		{
			pos: [ 366, 438 ],
			size: 354,
			colorIndex: 0,
		},
		{
			pos: [ -96, 1053 ],
			size: 610,
			colorIndex: 2,
		},
		{
			pos: [ 185, 1280 ],
			size: 337,
			colorIndex: 0,
		},
		{
			pos: [ -104, -53 ],
			size: 626,
			colorIndex: 2,
		},
		{
			pos: [ -225, 573 ],
			size: 600,
			colorIndex: 0,
		},
	],
};

const SAKIGAKE_COMMON_OPTION = {
	color: [
		{
			color: 0x15a1e9,
			alpha: 0.38,
			gradationType: 4,
		},
		{
			color: 0x23a8fc,
			alpha: 0.26,
			gradationType: 3,
		},
		{
			color: 0x68879f,
			alpha: 0.36,
			gradationType: 2,
		},
	],
};
const SAKIGAKE_OPTION = {
	...SAKIGAKE_COMMON_OPTION,
	positions: [
		{
			pos: [ 765, 321 ],
			size: 828,
			colorIndex: 1,
		},
		{
			pos: [ -299, 20 ],
			size: 695,
			colorIndex: 1,
		},
		{
			pos: [ 795, -343 ],
			size: 782,
			colorIndex: 2,
		},
		{
			pos: [ 56, 379 ],
			size: 463,
			colorIndex: 2,
		},
		{
			pos: [ 1159, 304 ],
			size: 451,
			colorIndex: 2,
		},
		{
			pos: [ 671, -29 ],
			size: 604,
			colorIndex: 1,
		},
		{
			pos: [ 115, -156 ],
			size: 505,
			colorIndex: 0,
		},
		{
			pos: [ 727, 500 ],
			size: 421,
			colorIndex: 0,
		},
		{
			pos: [ -140, 674 ],
			size: 453,
			colorIndex: 0,
		},
	],
};
const SAKIGAKE_SP_OPTION = {
	...SAKIGAKE_COMMON_OPTION,
	positions: [
		{
			pos: [ 375, 197 ],
			size: 688,
			colorIndex: 2,
		},
		{
			pos: [ 434, 822 ],
			size: 324,
			colorIndex: 0,
		},
		{
			pos: [ 356, 871 ],
			size: 663,
			colorIndex: 1,
		},
		{
			pos: [ -6, 1202 ],
			size: 451,
			colorIndex: 2,
		},
		{
			pos: [ -233, 794 ],
			size: 453,
			colorIndex: 0,
		},
		{
			pos: [ 279, 176 ],
			size: 531,
			colorIndex: 1,
		},
		{
			pos: [ -222, 495 ],
			size: 597,
			colorIndex: 2,
		},
		{
			pos: [ -257, -184 ],
			size: 663,
			colorIndex: 1,
		},
		{
			pos: [ 123, -184 ],
			size: 421,
			colorIndex: 0,
		},
	],
};

const FIELD_COMMON_OPTION = {
	color: [
		{
			color: 0x00b979,
			alpha: 0.35,
			gradationType: 4,
		},
		{
			color: 0x25b631,
			alpha: 0.3,
			gradationType: 3,
		},
		{
			color: 0x93ce58,
			alpha: 0.36,
			gradationType: 2,
		},
	],
};
const FIELD_OPTION = {
	...FIELD_COMMON_OPTION,
	positions: [
		{
			pos: [ 894, -298 ],
			size: 830,
			colorIndex: 2,
		},
		{
			pos: [ -174, 500 ],
			size: 764,
			colorIndex: 2,
		},
		{
			pos: [ 700, 532 ],
			size: 606,
			colorIndex: 2,
		},
		{
			pos: [ 1067, 481 ],
			size: 453,
			colorIndex: 0,
		},
		{
			pos: [ 744, -9 ],
			size: 401,
			colorIndex: 0,
		},
		{
			pos: [ -149, -29 ],
			size: 550,
			colorIndex: 0,
		},
		{
			pos: [ 102, -119 ],
			size: 429,
			colorIndex: 1,
		},
		{
			pos: [ 118, 402 ],
			size: 561,
			colorIndex: 1,
		},
		{
			pos: [ 795, 117 ],
			size: 549,
			colorIndex: 1,
		},
	],
};
const FIELD_SP_OPTION = {
	...FIELD_COMMON_OPTION,
	positions: [
		{
			pos: [ 310, 23 ],
			size: 830,
			colorIndex: 2,
		},
		{
			pos: [ 324, 313 ],
			size: 370,
			colorIndex: 0,
		},
		{
			pos: [ 154, 1145 ],
			size: 592,
			colorIndex: 2,
		},
		{
			pos: [ -190, 610 ],
			size: 616,
			colorIndex: 2,
		},
		{
			pos: [ 450, 1089 ],
			size: 396,
			colorIndex: 0,
		},
		{
			pos: [ -234, 877 ],
			size: 468,
			colorIndex: 1,
		},
		{
			pos: [ 404, 507 ],
			size: 549,
			colorIndex: 1,
		},
		{
			pos: [ -205, 0 ],
			size: 550,
			colorIndex: 0,
		},
		{
			pos: [ 27, -134 ],
			size: 429,
			colorIndex: 1,
		},
	],
};

const HOME_COMMON_OPTION = {
	color: [
		{
			color: 0x815db8,
			alpha: 0.35,
			gradationType: 4,
		},
		{
			color: 0x8763a1,
			alpha: 0.3,
			gradationType: 3,
		},
		{
			color: 0x867eba,
			alpha: 0.3,
			gradationType: 2,
		},
	],
};
const HOME_OPTION = {
	...HOME_COMMON_OPTION,
	positions: [
		{
			pos: [ 902, 14 ],
			size: 658,
			colorIndex: 2,
		},
		{
			pos: [ 628, 498 ],
			size: 711,
			colorIndex: 1,
		},
		{
			pos: [ -224, -106 ],
			size: 599,
			colorIndex: 2,
		},
		{
			pos: [ -103, 450 ],
			size: 581,
			colorIndex: 2,
		},
		{
			pos: [ 700, -161 ],
			size: 575,
			colorIndex: 1,
		},
		{
			pos: [ 220, 97 ],
			size: 497,
			colorIndex: 1,
		},
		{
			pos: [ 124, 14 ],
			size: 373,
			colorIndex: 0,
		},
		{
			pos: [ 123, 414 ],
			size: 448,
			colorIndex: 0,
		},
		{
			pos: [ 912, 346 ],
			size: 459,
			colorIndex: 0,
		},
	],
};
const HOME_SP_OPTION = {
	...HOME_COMMON_OPTION,
	positions: [
		{
			pos: [ -251, -152 ],
			size: 599,
			colorIndex: 2,
		},
		{
			pos: [ 441, 304 ],
			size: 497,
			colorIndex: 1,
		},
		{
			pos: [ 340, 248 ],
			size: 398,
			colorIndex: 0,
		},
		{
			pos: [ 375, -279 ],
			size: 575,
			colorIndex: 1,
		},
		{
			pos: [ 326, 830 ],
			size: 601,
			colorIndex: 2,
		},
		{
			pos: [ 512, 1059 ],
			size: 451,
			colorIndex: 0,
		},
		{
			pos: [ -237, 1152 ],
			size: 669,
			colorIndex: 1,
		},
		{
			pos: [ -85, 542 ],
			size: 517,
			colorIndex: 2,
		},
		{
			pos: [ -185, 703 ],
			size: 427,
			colorIndex: 0,
		},
	],
};

const CLUSTER_OPTION = {
	mode: 'cluster',
	fixed: true,
	color: [],
	positions: [],
};

/**
 * XorShift for js
 */

class XorShift {
	constructor( seed = 88675123 ) {
		this.x = 123456789;
		this.y = 362436069;
		this.z = 521288629;
		this.w = seed;
	}

	// XorShift
	next() {
		let t;

		t = this.x ^ ( this.x << 11 );
		this.x = this.y;
		this.y = this.z;
		this.z = this.w;
		return ( this.w = this.w ^ ( this.w >>> 19 ) ^ ( t ^ ( t >>> 8 ) ) );
	}

	nextInt( min, max ) {
		const r = Math.abs( this.next() );
		return min + ( r % ( max + 1 - min ) );
	}
}

// Older jQuery version.
const $ = jQuery;

const Random = new XorShift( Math.floor( Math.random() * 99999999 ) );

let prevScrollY = 0;
let scrollDistances = [];
// scroll の検知
const scrollDetect = scrollY => {
	const scrollDistance = prevScrollY - scrollY;
	scrollDistances.push( scrollDistance );

	if ( scrollDistances.length > 10 ) {
		const overSize = scrollDistances.length - 10;
		scrollDistances = scrollDistances.slice( overSize );
	}

	// 移動量が10のものだけ検出してそれが5フレーム以上の場合にスクロール判定
	return scrollDistances.filter( x => Math.abs( x ) > 10 ).length >= 5;
};

const createLayer = ( { tick, stageSize, layer, inTime, outTime } ) => {
	const circles = layer.circles.map( x => createCircle( {
		...x,
		tick,
		size: stageSize,
		inTime,
		stayTime: 100,
		outTime,
		alpha: {
			min: 0,
			max: 1,
		},
		gradationType: 0,
	} )
	);

	return {
		id: layer.id,
		circles,
		start: tick,
		inTime,
		stayTime: 100,
		outTime,
		isDead: false,
	};
};

const updateLayer = ( { tick, stageSize, layer } ) => {
	const distance = tick - layer.start;
	layer.isDead = layer.inTime + layer.stayTime + layer.outTime < distance;

	layer.circles.forEach( x => circleUpdate( {
		circle: x,
		tick,
		size: stageSize,
	} ) );
};

const calculatePosAndScale = ( pos, scale, size, isBottom ) => {
	const w = isSP() ? 750 : 1400;
	const h = isSP() ? 10673 : 5817;
	// 横幅に合わせてスケール(デザインの1400pxを基準)
	const sizeScale = ( size.width / w );
	const y = isBottom ? size.height - ( ( h - pos.y ) * sizeScale ) : pos.y * sizeScale;

	return {
		pos: {
			x: pos.x * sizeScale,
			y,
		},
		scale: scale * sizeScale,
	};
};

const createSprite = gradationType => {
	switch ( gradationType ) {
		case 0:
			return {
				sprite: PIXI.Sprite.from( '/content/themes/tokai-univ-base/assets/images/common/bg_sprite_circle.png' ),
				size: 588,
			};
		case 1:
			return {
				sprite: PIXI.Sprite.from( '/content/themes/tokai-univ-base/assets/images/common/bg_sprite_circle_static.png' ),
				size: 1000,
			};
		case 2:
			return {
				sprite: PIXI.Sprite.from( '/content/themes/tokai-univ-base/assets/images/common/bg_sprite_circle_cluster_0.png' ),
				size: 524,
			};
		case 3:
			return {
				sprite: PIXI.Sprite.from( '/content/themes/tokai-univ-base/assets/images/common/bg_sprite_circle_cluster_1.png' ),
				size: 548,
			};
		case 4:
			return {
				sprite: PIXI.Sprite.from( '/content/themes/tokai-univ-base/assets/images/common/bg_sprite_circle_cluster_2.png' ),
				size: 413,
			};
		default:
			return {
				sprite: PIXI.Sprite.from( '/content/themes/tokai-univ-base/assets/images/common/bg_sprite_circle.png' ),
				size: 588,
			};
	}
};

const createCircle = ( {
						   tick,
						   size,
						   color,
						   targetSize,
						   pos,
						   alpha,
						   inTime,
						   stayTime,
						   outTime,
						   isBottom,
						   gradationType,
					   } ) => {
	const { sprite, size: spriteSize } = createSprite( gradationType );

	// color
	sprite.tint = color;

	// scale
	sprite.anchor.set( 0.5 );

	const scale = targetSize / spriteSize;
	sprite.targetScale = scale;
	sprite.target = {
		x: pos[ 0 ],
		y: pos[ 1 ],
	};
	sprite.isBottom = isBottom;

	const { pos: p, scale: s } = calculatePosAndScale( sprite.target, scale, size, isBottom );
	sprite.scale.set( s );
	sprite.position.set( p.x, p.y );

	// lifetime
	sprite.start = tick;

	sprite.inTime = inTime || 0;
	sprite.stayTime = stayTime || 1000;
	sprite.outTime = outTime || 0;

	sprite.alphaMax = typeof alpha === 'object' ? alpha.max : Random.nextInt( 3, 10 ) / 10;
	sprite.alpha = typeof alpha === 'object' ? alpha.min : 0;
	sprite.isDead = false;

	return sprite;
};

const circleUpdate = ( { circle, tick, size, isBottom } ) => {
	const distance = tick - circle.start;

	circle.isDead = circle.inTime + circle.stayTime + circle.outTime < distance;

	const { pos: p, scale: s } = calculatePosAndScale( circle.target, circle.targetScale, size, isBottom );
	circle.scale.set( s );
	circle.position.set( p.x, p.y );

	// alpha ease
	if ( circle.inTime > distance ) {
		const alpha = ( distance / circle.inTime ) * circle.alphaMax;
		circle.alpha = alpha;
	} else if ( circle.inTime + circle.stayTime < distance ) {
		const alpha =
			( 1 -
				( distance - circle.inTime - circle.stayTime ) / circle.outTime ) *
			circle.alphaMax;
		circle.alpha = alpha;
	} else {
		circle.alpha = circle.alphaMax;
	}
};

const isSP = () => {
	return ( ( window.matchMedia( '(orientation: portrait)' ).matches || window.matchMedia( '(orientation: landscape)' ).matches ) && window.matchMedia( '(max-width: 949px)' ).matches );
};

const getOption = serverOption => {
	switch ( serverOption.mode ) {
		case 'animation':
			return {
				...TOP_OPTION,
				...serverOption,
			};
		case 'static':
			if ( typeof serverOption.level === 'number' ) {
				const date = new Date( serverOption.time );
				if ( date.getHours() >= 7 && date.getHours() < 12 ) {
					// morning
					if ( serverOption.level === 2 ) {
						return {
							...SECOUND_LAYER_OPTION,
							...( isSP() ? MORNING_SP_OPTION : MORNING_OPTION ),
							...serverOption,
						};
					} else {
						return {
							...THIRD_LAYER_OPTION,
							...( isSP() ? MORNING_3RD_SP_OPTION : MORNING_3RD_OPTION ),
							...serverOption,
						};
					}
				} else if ( date.getHours() >= 12 && date.getHours() < 18 ) {
					// noon
					if ( serverOption.level === 2 ) {
						return {
							...SECOUND_LAYER_OPTION,
							...( isSP() ? NOON_SP_OPTION : NOON_OPTION ),
							...serverOption,
						};
					} else {
						return {
							...THIRD_LAYER_OPTION,
							...( isSP() ? NOON_3RD_SP_OPTION : NOON_3RD_OPTION ),
							...serverOption,
						};
					}
				} else {
					// night
					if ( serverOption.level === 2 ) {
						return {
							...SECOUND_LAYER_OPTION,
							...( isSP() ? NIGHT_SP_OPTION : NIGHT_OPTION ),
							...serverOption,
						};
					} else {
						return {
							...THIRD_LAYER_OPTION,
							...( isSP() ? NIGHT_3RD_SP_OPTION : NIGHT_3RD_OPTION ),
							...serverOption,
						};
					}
				}
			}

			// today
			{
				const todayOption = isSP() ? TODAY_SP_OPTION : TODAY_OPTION;
				return {
					...SECOUND_LAYER_OPTION,
					...todayOption,
					...serverOption,
				};
			}
		case 'cluster':
			switch ( serverOption.page ) {
				case 'cluster-campuslife': {
					const option = isSP() ? CAMPUSLIFE_SP_OPTION : CAMPUSLIFE_OPTION;
					return {
						...CLUSTER_OPTION,
						...option,
						...serverOption,
					};
				}
				case 'cluster-sakigake': {
					const option = isSP() ? SAKIGAKE_SP_OPTION : SAKIGAKE_OPTION;
					return {
						...CLUSTER_OPTION,
						...option,
						...serverOption,
					};
				}
				case 'cluster-field': {
					const option = isSP() ? FIELD_SP_OPTION : FIELD_OPTION;
					return {
						...CLUSTER_OPTION,
						...option,
						...serverOption,
					};
				}
				case 'cluster-home': {
					const option = isSP() ? HOME_SP_OPTION : HOME_OPTION;
					return {
						...CLUSTER_OPTION,
						...option,
						...serverOption,
					};
				}
				default:
			}

			return {
				...CLUSTER_OPTION,
				...serverOption,
			};
		default:
			return {
				...TOP_OPTION,
				...serverOption,
			};
	}
};

$( () => {
	// TOKAI_UNIV_BG_CANVAS は html に直接挿入される
	if ( ! window.TOKAI_UNIV_BG_CANVAS ) {
		return;
	}
	// eslint-disable-next-line no-undef
	let option = getOption( TOKAI_UNIV_BG_CANVAS );
	let circles = [];
	let layers = [];
	let tick = 0;
	let nextAddTick = 0;
	let layerSequence = [];
	let currentLayer = -1;
	let prevDevice = '';

	const container = new PIXI.ParticleContainer( 100, {
		scale: true,
		position: true,
		alpha: true,
		tint: true,
	} );

	const reset = () => {
		circles = [];
		layers = [];
		tick = 0;
		nextAddTick = 0;
		layerSequence = [];
		currentLayer = -1;
		// eslint-disable-next-line no-undef
		option = getOption( TOKAI_UNIV_BG_CANVAS );

		container.removeChildren();

		// 初期データ作成
		if ( option.mode === 'animation' ) {
			layerSequence = option.layers.map( x => x.id ).reverse();
		} else {
			const newCircles = option.positions.map( x => {
				// color を index から値に変換
				const c = option.color[ x.colorIndex ];
				return {
					...x,
					...c,
				};
			} ).map( x => {
				return createCircle( {
					tick,
					...x,
					size: pageSize,
					mode: option.mode,
					alpha: {
						min: x.alpha,
						max: x.alpha,
					},
					pos: [ ( x.pos[ 0 ] + x.size / 2 ), ( x.pos[ 1 ] + x.size / 2 ) ],
					scale: x.size / 1000,
					targetSize: x.size,
					inTime: 10,
					stayTime: 10,
					outTime: 10,
				} );
			} );

			newCircles.forEach( x => container.addChild( x ) );
			circles = [ ...newCircles, ...circles ];
		}
	};

	const canvas = $( '#bg-canvas' );
	const app = new PIXI.Application( {
		view: canvas[ 0 ],
		width: 1400,
		height: 1400,
		antialias: false,
		transparent: true,
		autoDensity: true,
		resolution: window.devicePixelRatio || 1,
	} );

	const pageWrapper = document.querySelector( '.page-wrapper' );
	let pageSize = {
		width: pageWrapper.clientWidth,
		height: pageWrapper.clientHeight,
	};
	let windowSize = {
		width: window.innerWidth,
		height: window.innerHeight,
	};
	const resizeHandler = () => {
		if ( window.matchMedia( '(min-width: 1240px)' ).matches ) {
			pageSize = {
				width: pageWrapper.clientWidth,
				height: pageWrapper.clientHeight,
			};
			windowSize = {
				width: window.innerWidth,
				height: window.innerHeight,
			};
			if ( prevDevice !== '' && prevDevice === 'mobile' ) {
				reset();
			}
			prevDevice = 'desktop';
		} else if ( isSP() ) {
			// MOBILE
			pageSize = {
				width: pageWrapper.clientWidth,
				height: pageWrapper.clientHeight,
			};
			windowSize = {
				width: window.innerWidth,
				height: window.innerHeight,
			};
			if ( prevDevice !== '' && prevDevice === 'desktop' ) {
				reset();
			}
			prevDevice = 'mobile';
		} else {
			pageSize = {
				width: 1240,
				height: pageWrapper.clientHeight,
			};
			windowSize = {
				width: 1240,
				height: window.innerHeight,
			};
			if ( prevDevice !== '' && prevDevice === 'mobile' ) {
				reset();
			}
			prevDevice = 'desktop';
		}
		app.renderer.resize( windowSize.width, windowSize.height );
	};
	resizeHandler();

	// resize
	window.addEventListener( 'resize', resizeHandler );

	app.stage.addChild( container );

	reset();

	app.ticker.add( _ => {
		const isScrolling = scrollDetect( window.scrollY );
		const deltaMS = app.ticker.deltaMS;

		if ( option.mode === 'animation' ) {
			tick += isScrolling ? deltaMS * option.speed.scrollMultiply : deltaMS;

			if ( tick >= nextAddTick ) {
				currentLayer = ( currentLayer + 1 ) % option.layers.length;
				const targetLayer = option.layers.find( x => x.id === layerSequence[ currentLayer ] );
				const fadeinTime = layers.length === 0 ? Random.nextInt( option.speed.inTime.min, option.speed.inTime.max ) : layers[ layers.length - 1 ].outTime;
				const fadeoutTime = Random.nextInt( option.speed.outTime.min, option.speed.outTime.max );

				const tick2 = layers.length === 0 ? tick : layers[ layers.length - 1 ].start + layers[ layers.length - 1 ].inTime;

				const layer = createLayer( {
					tick: tick2,
					stageSize: windowSize,
					inTime: fadeinTime,
					outTime: fadeoutTime,
					layer: {
						...targetLayer,
						circles: targetLayer.circles.map( x => {
							return {
								...x,
								pos: [ ( x.pos[ 0 ] + x.size / 2 ), ( x.pos[ 1 ] + x.size / 2 ) ],
								scale: x.size / 588,
								targetSize: x.size,
							};
						} ),
					},
				} );
				layer.circles.forEach( layer => {
					container.addChild( layer );
				} );

				layers = [ ...layers, layer ];
				nextAddTick = tick2 + fadeinTime;
			}

			// update
			layers.forEach( x => {
				updateLayer( {
					layer: x,
					tick,
					stageSize: windowSize,
				} );
			} );

			// destroy
			layers = layers.filter( layer => {
				if ( layer.isDead ) {
					layer.circles.forEach( x => {
						container.removeChild( x );
					} );
				}
				return ! layer.isDead;
			} );
		} else {
			tick = 10;
			// update
			circles.forEach( x => {
				circleUpdate( {
					circle: x,
					tick,
					size: pageSize,
					isBottom: x.isBottom,
				} );
			} );

			// destroy
			circles = circles.filter( x => {
				if ( x.isDead ) container.removeChild( x );
				return ! x.isDead;
			} );
		}

		container.y = option.fixed ? 0 : -window.scrollY;

		prevScrollY = window.scrollY;
	} );
} );
